import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuth } from '../auth'
import { subAccountRoutes } from '../constants/agency/subAccounts'
import AccountsWrapper from '@/pmd/components/agency/AccountsWrapper.vue'

const Account = () =>
  import(/* webpackChunkName: "accounts" */ '@/pmd/pages/agency/Account.vue')

const LocationsList = () =>
  import(/* webpackChunkName: "accounts" */ '@/pmd/pages/LocationsList.vue')

const AccountV2 = () =>
  import(/* webpackChunkName: "accounts" */ '@/pmd/pages/agency/AccountV2.vue')

  const AddAccountV2 = () =>
    import(
      /* webpackChunkName: "add-location" */ '@/pmd/pages/agency/AddAccountV2.vue'
    )

    const AccountDetail = () =>
      import(
        /* webpackChunkName: "account-details" */ '@/pmd/pages/agency/AccountDetail.vue'
      )

const AddAccountMapV2 = () =>
  import(
    /* webpackChunkName: "map-search" */ '@/pmd/pages/agency/AddAccountMapV2.vue'
  )

  const AccountDetailsV2 = () =>
    import(
      /* webpackChunkName: "account-details" */ '@/pmd/pages/agency/AccountDetailsV2.vue'
    )
// Dynamic component loader that checks feature flag
const getAccountsListComponent = () => {
  return new Promise((resolve, reject) => {
    const MAX_RETRIES = 50; // 5 seconds maximum wait
    let retryCount = 0;
    let timeoutId: NodeJS.Timeout;

    import('../../store').then(storeModule => {
      const store = storeModule.default
      
      // Function to check if feature flags are loaded
      const waitForFeatureFlags = () => {
        if (retryCount >= MAX_RETRIES) {
          console.warn('Max retries reached waiting for feature flags, falling back to default view');
          clearTimeout(timeoutId);
          import(/* webpackChunkName: "accounts" */ '@/pmd/pages/agency/ListAccounts.vue')
            .then(m => resolve(m.default))
            .catch(reject);
          return;
        }

        const isRevampEnabled = store.getters['featureFlags/getForCompany']('enable-97-297-ui-revamp')
        
        if (isRevampEnabled === undefined || isRevampEnabled === null) {
          // If feature flags aren't loaded yet, try again in 100ms
          retryCount++;
          timeoutId = setTimeout(waitForFeatureFlags, 100);
          return;
        }

        // Clear any existing timeout since we got our answer
        clearTimeout(timeoutId);
        
        if (isRevampEnabled) {
          import(/* webpackChunkName: "accounts" */ '@/pmd/pages/LocationsList.vue')
            .then(m => resolve(m.default))
            .catch(reject)
        } else {
          import(/* webpackChunkName: "accounts" */ '@/pmd/pages/agency/ListAccounts.vue')
            .then(m => resolve(m.default))
            .catch(reject)
        }
      }

      // Start checking for feature flags
      waitForFeatureFlags()
    }).catch(error => {
      console.error('Error in accounts list loader:', error)
      // Fallback to ListAccounts component
      import(/* webpackChunkName: "accounts" */ '@/pmd/pages/agency/ListAccounts.vue')
        .then(m => resolve(m.default))
        .catch(reject)
    })
  })
}

// Navigation guard to check feature flags and load appropriate component
const checkFeatureAndNavigate = async (to: any, from: any, next: any) => {
  try {
    // First check auth
    const authNext = (authTo?: any) => {
      if (authTo && authTo !== true) {
        next(authTo);
        return;
      }
      // If auth passes, proceed with component check
      getAccountsListComponent()
        .then(() => {
          next();
        })
        .catch(error => {
          console.error('Component loading error:', error);
          next(error);
        });
    };

    await requireAuth(to, from, authNext);
  } catch (error) {
    console.error('Navigation guard error:', error);
    next(error);
  }
}

const AccountBulkActionHistory = () =>
  import(
    /* webpackChunkName: "accounts" */ '@/pmd/pages/agency/AccountBulkActionHistory.vue'
  )



export const subAccounts: RouteConfig[] = [
  {
    path: '/sub-accounts',
    component: Account,
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: subAccountRoutes.default,
        component: LocationsList,
        meta: {
          translations: [Modules.Snapshots, Modules.SmartList, Modules.Task, Modules.ContactDetail],
        },
      },
      {
        path: 'dashboard/:locationId',
        name: subAccountRoutes.dashboard,
        component: AccountV2,
      },
      {
        path: 'schedules',
        name: subAccountRoutes.schedules,
        component: AccountV2,
      },
      {
        path: 'bulk-action-history',
        name: subAccountRoutes.bulkActionHistory,
        component: AccountBulkActionHistory,
      },
    ],
  },
  {
    path: '/sub-accounts-v2',
    component: LocationsList,
    beforeEnter: requireAuth,
  },
  {
    path: '/accounts',
    component: Account,
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: subAccountRoutes.accounts.default,
        component: AccountsWrapper,
        meta: {
          translations: [Modules.Snapshots, Modules.SmartList, Modules.Task, Modules.ContactDetail],
        },
      },
      {
        path: 'add/:id?',
        name: subAccountRoutes.accounts.add,
        component: AddAccountV2,
      },
      {
        path: 'search',
        name: subAccountRoutes.accounts.search,
        component: AddAccountMapV2,
        meta: {
          translations: [Modules.Snapshots],
        },
      },
      {
        path: 'detail/:account_id',
        name: subAccountRoutes.accounts.detail,
        component: AccountDetailsV2,
      }
    ],
  },
]
